module.exports = __webpack_public_path__ + "img/shareBoxSel.382c4357.svg";